<template>
  <div class="spinner"></div>
</template>

<script>
export default {
  name: 'Spinner',
};
</script>

<style scoped>
.spinner {
  border: 4px solid #e0e0e0;
  border-top: 4px solid #0baaff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
